<div class="modal-content border-0 terminal-shipment-modal">

  <div class="modal-header d-flex justify-content-between align-items-start">
    <div>
      <h5 class="modal-title m-0">{{ title }}</h5>
      <p class="modal-subtitle m-0">Ticket #{{ reqId }}</p>
    </div>
    <button type="button" class="close-btn" aria-label="Close" (click)="cancel()">&times;</button>
  </div>

  <div class="modal-body" [formGroup]="form">

    <!-- ---------- Device (only a choice when the order has several) ---------- -->
    @if (deviceOptions.length > 1) {
      <p class="section-label">DEVICE</p>
      <div class="section-box mb-4">
        <label class="field-label" for="ts_device">Terminal Device <span class="required">*</span></label>
        <select id="ts_device" class="form-field" formControlName="tdi_id" [class.is-invalid]="invalid('tdi_id')">
          @for (device of deviceOptions; track device.tdi_id) {
            <option [value]="device.tdi_id">{{ deviceLabel(device) }}</option>
          }
        </select>
      </div>
    } @else if (selected(); as device) {
      <p class="device-line">Device <span>{{ deviceLabel(device) }}</span></p>
    }

    @if (mode === 'shipment') {
      <!-- ---------- Device & tracking ---------- -->
      <p class="section-label">DEVICE &amp; TRACKING</p>
      <div class="section-box mb-4">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="field-label" for="ts_serial">Serial Number @if (!isReject) {<span class="required">*</span>}</label>
            <input id="ts_serial" type="text" class="form-field" placeholder="Enter serial number"
              formControlName="serial_number" [class.is-invalid]="invalid('serial_number')" />
            @if (hasError('serial_number', 'required')) { <p class="field-error">Please enter a serial number</p> }
            @if (hasError('serial_number', 'minlength')) { <p class="field-error">Minimum 3 characters</p> }
            @if (hasError('serial_number', 'pattern')) { <p class="field-error">Only letters, numbers, spaces and + - _ / allowed</p> }
          </div>
          <div class="col-md-6 mb-3">
            <label class="field-label" for="ts_tracking">Tracking Number @if (!isReject) {<span class="required">*</span>}</label>
            <input id="ts_tracking" type="text" class="form-field" placeholder="Enter tracking number"
              formControlName="tracking_number" [class.is-invalid]="invalid('tracking_number')" />
            @if (hasError('tracking_number', 'required')) { <p class="field-error">Please enter a tracking number</p> }
            @if (hasError('tracking_number', 'minlength')) { <p class="field-error">Minimum 3 characters</p> }
            @if (hasError('tracking_number', 'pattern')) { <p class="field-error">Only letters, numbers, spaces and hyphens allowed</p> }
          </div>
          <div class="col-md-6 mb-1">
            <label class="field-label" for="ts_track_link">Track Link @if (!isReject) {<span class="required">*</span>}</label>
            <input id="ts_track_link" type="text" class="form-field" placeholder="https://..."
              formControlName="track_link" [class.is-invalid]="invalid('track_link')" />
            @if (hasError('track_link', 'required')) { <p class="field-error">Please enter a track link</p> }
            @if (hasError('track_link', 'pattern')) { <p class="field-error">Must start with http:// or https://</p> }
          </div>
          <div class="col-md-6 mb-1">
            <label class="field-label" for="ts_carrier">Carrier Name @if (!isReject) {<span class="required">*</span>}</label>
            <input id="ts_carrier" type="text" class="form-field" placeholder="e.g. USPS, FedEx, UPS"
              formControlName="carrier" [class.is-invalid]="invalid('carrier')" />
            @if (hasError('carrier', 'required')) { <p class="field-error">Please enter a carrier name</p> }
          </div>
        </div>
      </div>

      <!-- ---------- Dates & status ---------- -->
      <p class="section-label">DATES &amp; STATUS</p>
      <div class="section-box mb-4">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="field-label" for="ts_ship_date">Ship Date @if (!isReject) {<span class="required">*</span>}</label>
            <input id="ts_ship_date" type="text" class="form-field date-field" placeholder="MM/DD/YYYY" readonly bsDatepicker
              [bsConfig]="bsConfig" [maxDate]="today" formControlName="ship_date" [class.is-invalid]="invalid('ship_date')" />
            @if (hasError('ship_date', 'required')) { <p class="field-error">Please select a ship date</p> }
          </div>
          <div class="col-md-6 mb-3">
            <label class="field-label" for="ts_est_date">Estimated Delivery @if (!isReject) {<span class="required">*</span>}</label>
            <input id="ts_est_date" type="text" class="form-field date-field" placeholder="MM/DD/YYYY" readonly bsDatepicker
              [bsConfig]="bsConfig" [minDate]="shipDate" formControlName="est_delivery_date"
              [class.is-invalid]="invalid('est_delivery_date')" />
            @if (hasError('est_delivery_date', 'required')) { <p class="field-error">Please select an estimated delivery date</p> }
            @if (hasError('est_delivery_date', 'beforeStart')) { <p class="field-error">Can't be before the ship date</p> }
          </div>
          <div class="col-md-6 mb-1">
            <label class="field-label" for="ts_status">Status <span class="required">*</span></label>
            <select id="ts_status" class="form-field" formControlName="status" [class.is-invalid]="invalid('status')">
              @for (option of statusOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
          @if (emailLabel) {
            <div class="col-md-6 mb-1 d-flex align-items-end">
              <div class="checkbox-field mb-2">
                <input type="checkbox" id="ts_send_email" class="secondary-checkbox" formControlName="send_email" />
                <label for="ts_send_email">{{ emailLabel }}</label>
              </div>
            </div>
          }

          <!-- Marking it Delivered here records the delivery itself, so it asks for both. -->
          @if (isDelivered) {
            <div class="col-md-6 mb-1 mt-3">
              <label class="field-label" for="ts_delivery_date">Delivery Date <span class="required">*</span></label>
              <input id="ts_delivery_date" type="text" class="form-field date-field" placeholder="MM/DD/YYYY" readonly bsDatepicker
                [bsConfig]="bsConfig" [minDate]="shipDate" [maxDate]="today" formControlName="delivery_date"
                [class.is-invalid]="invalid('delivery_date')" />
              @if (hasError('delivery_date', 'required')) { <p class="field-error">Please select a delivery date</p> }
              @if (hasError('delivery_date', 'beforeStart')) { <p class="field-error">Can't be before the ship date</p> }
            </div>
            <div class="col-md-6 mb-1 mt-3">
              <label class="field-label" for="ts_condition">Condition on Arrival</label>
              <select id="ts_condition" class="form-field" formControlName="condition_on_arrival">
                <option value="">Select...</option>
                @for (option of conditionOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </div>
          }
        </div>
      </div>
    } @else {
      <!-- ---------- Delivery ---------- -->
      <p class="section-label">DELIVERY</p>
      <div class="section-box mb-4">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="field-label" for="ts_delivery_date">Delivery Date <span class="required">*</span></label>
            <input id="ts_delivery_date" type="text" class="form-field date-field" placeholder="MM/DD/YYYY" readonly bsDatepicker
              [bsConfig]="bsConfig" [minDate]="shipDate" [maxDate]="today" formControlName="delivery_date"
              [class.is-invalid]="invalid('delivery_date')" />
            @if (hasError('delivery_date', 'required')) { <p class="field-error">Please select a delivery date</p> }
            @if (hasError('delivery_date', 'beforeStart')) { <p class="field-error">Can't be before the ship date</p> }
          </div>
          <div class="col-md-6 mb-3">
            <label class="field-label" for="ts_condition">Condition on Arrival</label>
            <select id="ts_condition" class="form-field" formControlName="condition_on_arrival">
              <option value="">Select...</option>
              @for (option of conditionOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
          <div class="col-md-6 mb-1">
            <label class="field-label" for="ts_delivery_status">Status <span class="required">*</span></label>
            <select id="ts_delivery_status" class="form-field" formControlName="status" [class.is-invalid]="invalid('status')">
              @for (option of statusOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
          @if (emailLabel) {
            <div class="col-md-6 mb-1 d-flex align-items-end">
              <div class="checkbox-field mb-2">
                <input type="checkbox" id="ts_send_email" class="secondary-checkbox" formControlName="send_email" />
                <label for="ts_send_email">{{ emailLabel }}</label>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- ---------- Notes (added to the ticket's notes) ---------- -->
    <p class="section-label">NOTES</p>
    <div class="section-box">
      <label class="field-label" for="ts_notes">Notes <span class="required">*</span></label>
      <textarea id="ts_notes" rows="3" maxlength="1000" class="form-field" placeholder="Enter notes"
        formControlName="notes" [class.is-invalid]="invalid('notes')"></textarea>
      <div class="d-flex justify-content-between">
        <p class="field-error">@if (invalid('notes')) { Please enter a note }</p>
        <small class="counter">{{ notesLength }}/1000</small>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="saving()" (click)="save()">
      {{ saving() ? 'Saving...' : 'Submit' }}
    </button>
  </div>
</div>
